/**
 *
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { attachAllBindings, getStateValueByPath, releaseAllBindings, } from './Common';
export function GenericReduxBindableMixin(Base, getStore) {
    var _a;
    return _a = class extends Base {
            attachReduxBindings(postUpdateCallback) {
                this._reduxBindings = attachAllBindings(this, postUpdateCallback);
            }
            removeReduxBindings() {
                if (this._reduxBindings) {
                    releaseAllBindings(this, this._reduxBindings);
                }
            }
            /** @override */ dispatch(reduxAction) {
                this.asyncDispatch(reduxAction);
            }
            asyncDispatch(reduxAction) {
                return __awaiter(this, void 0, void 0, function* () {
                    (yield this.getStore()).dispatch(reduxAction);
                });
            }
            getStateValueByPath(path) {
                return __awaiter(this, void 0, void 0, function* () {
                    return getStateValueByPath((yield this.getStore()).getState(), path);
                });
            }
            /** @override */ getStore() {
                return __awaiter(this, void 0, void 0, function* () {
                    return getStore();
                });
            }
        },
        _a._reduxStatePaths = new Map(),
        _a;
}
